import { Box } from "@chakra-ui/react";
import { FC, ReactElement, useEffect, useState } from "react";
import PartnerService from "services/partners/partner-service";
import LogosTable from "components/table";
import { useNavigate } from "react-router-dom";

interface PartnerSalesProps {
    partner: any
}

const PartnerSales: FC<PartnerSalesProps> = ({ partner }) => {
    const navigate = useNavigate();
    const [partnerOrders, setPartnerOrders] = useState<any>([]);
    const [totalOrder, setTotalOrder] = useState<number>(0);
    const [maxCountResult, setMaxCountResult] = useState<number>(100);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);
        PartnerService.GetSales(partner.id, 0, maxCountResult).then((res: any) => {
            if (res.result) {
                setPartnerOrders(res.result.items);
                setTotalOrder(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const handleClickRow = (order: any) => {
        window.open(`/orders/${order.order.id}`);
    };

    if (isLoading)
        return <Box>Loading...</Box>;

    return (
        <Box>
            <Box>
                <LogosTable
                    caption={'Riwayat Penjualan'}
                    headers={[{ label: 'Tanggal' }, { label: 'Program' }, { label: 'No Invoice' }, { label: "Client" }, { label: 'Jumlah', isNumeric: true }, { label: 'Komisi', isNumeric: true }]}
                    rows={[{ propertyName: 'order.creationTime', isDatetime: true }, { propertyName: 'order.program.name' }, { propertyName: 'order.invoiceNo' }, { propertyName: 'client.fullName' }, { propertyName: 'order.amount', isNumeric: true }, { propertyName: 'commissionFee', isNumeric: true }]}
                    data={partnerOrders}
                    onRowClick={handleClickRow}
                />
            </Box>
        </Box>
    );
};

export default PartnerSales;